import React, { useEffect, useState } from 'react';
import { Typography } from '@material-ui/core';
import BackgroundCard from '../../../../Common/P2P/Header/BackgroundCard';
import BorrowerForm from './BorrowerForm';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import { useHistory } from 'react-router-dom';
import FooterBar from '../../../../Common/P2P/Header/FooterBar';
import { useDispatch, useSelector } from 'react-redux';
import { fetchBorrowerDetails } from '../dashboardAction';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import BorrowIcon from '../../../../utils/assests/borrower-icon.jpg';
import ReviewIconTwo from '../../../../utils/assests/new-rev-2.png';
import ReviewIconThree from '../../../../utils/assests/new-rev-3.png';

function BorrowerInfo() {
  let dispatch = useDispatch();
  const history = useHistory();
  const [errorMessage, seterrorMessage] = useState<string>('');
  const { borrowerResponse } = useSelector((state: any) => state.dashboard);

  useEffect(() => {
    dispatch(fetchBorrowerDetails());
  }, []);

  useEffect(() => {
    if (borrowerResponse?.status) {
    } else if (!borrowerResponse?.status) {
      seterrorMessage(borrowerResponse?.message);
    }
  }, [borrowerResponse]);

  const Item = styled(Paper)(({ theme }: any) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  }));
  const handleInvestmentSummary = () => {
    history.push('/p2p/investmentSummaryInfo');
  };

  const recentTransation = () => {
    history.push('/p2p/recentTransactions');
  };

  const handleKnowMore = (type: string) => {
    // history.push({
    //     pathname: `/p2p/investmentSummary/${type}`
    // })
  };

  return (
    <>
      <Box className='pageHeadingText'>
        <Typography variant='h6'>
          Review your <strong>investments</strong> <br /> across categories
        </Typography>
      </Box>

      <BackgroundCard>
        <Card className='redBorder'>
          <CardContent>
            <Grid
              container
              alignItems='center'
              justifyContent='center'
              columnSpacing={2}
              className='smallCardHeading'
            >
              <Grid item>
                <img src={BorrowIcon} alt='' width='100%' />
              </Grid>
              <Grid item>
                <Typography variant='h2'>
                  Borrower <br /> information
                </Typography>
              </Grid>
            </Grid>
            <BorrowerForm
              borrowerResponse={borrowerResponse}
              errorMessage={errorMessage}
              handleKnowMore={handleKnowMore}
            />
          </CardContent>
        </Card>
        <Grid
          container
          spacing={3}
          justifyContent='center'
          alignItems='center'
          className='threeCards'
        >
          <Grid item xs={4}>
            <Card className='redBorder' onClick={handleInvestmentSummary}>
              <CardContent>
                <img src={ReviewIconTwo} alt='' />
              </CardContent>
            </Card>
            <Typography>
              Investment <br /> summary
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <Card className='redBorder' onClick={recentTransation}>
              <CardContent>
                <img src={ReviewIconThree} alt='' />
              </CardContent>
            </Card>{' '}
            <Typography>
              Recent <br /> transaction
            </Typography>
          </Grid>
        </Grid>

        <FooterBar />
      </BackgroundCard>
    </>
  );
}
export default BorrowerInfo;
